import classic from './classic'
import fig from './fig'
import glassy from './glassy'
import ifsc from './ifsc'
import sstv from './sstv'
import swiss1 from './swiss1'
import swissWrestling2026 from './swiss-wrestling-2026'
import uiaa from './uiaa'
import various from './various'
export default [].concat(classic, fig, glassy, ifsc, sstv, swiss1, swissWrestling2026, uiaa, various)



// WEBPACK FOOTER //
// ./src/store/templates/index.js